module.exports = __webpack_public_path__ + "img/red_gold1.96b0caa9.png";